// extracted by mini-css-extract-plugin
export default {"container":"DeleteStudentModal_container__7a6Y7","description":"DeleteStudentModal_description__qzaWj","button":"DeleteStudentModal_button__NoKcD"};